import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MicroFrontendErrorType } from './MicroFrontendErrorType';
const message = {
    [MicroFrontendErrorType.ConnectionLost]: 'Something went wrong. Please check your connection or refresh the page.',
    [MicroFrontendErrorType.Exception]: 'Something went wrong. Please refresh or contact the support.',
};
const images = {
    [MicroFrontendErrorType.ConnectionLost]: 'https://cdn.branch.io/dashboard/icons/ic_server-error1.svg',
    [MicroFrontendErrorType.Exception]: 'https://cdn.branch.io/dashboard/icons/ic_server-error2.svg',
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        height: '100%',
    },
    image: {
        height: 100,
    },
    text: {
        fontSize: 20,
        lineHeight: '21.8px',
        color: 'fff',
    },
};
const MicroFrontendError = (props) => {
    const getErrorMessage = () => props.type
        ? message[props.type]
        : message[MicroFrontendErrorType.Exception];
    const getImage = () => props.type ? images[props.type] : images[MicroFrontendErrorType.Exception];
    return (_jsxs("div", Object.assign({ style: styles.container }, { children: [_jsx("img", { src: getImage(), alt: "", style: styles.image }), _jsx("div", Object.assign({ style: styles.text }, { children: getErrorMessage() }))] })));
};
export default MicroFrontendError;
//# sourceMappingURL=MicroFrontendError.js.map